/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Butansprechpersonextern3Inputs */

const de__field_butansprechpersonextern3 = /** @type {(inputs: _Field_Butansprechpersonextern3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`externe Ansprechsperson BuT`)
};

/**

* @param {_Field_Butansprechpersonextern3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_butansprechpersonextern3 = /** @type {((inputs?: _Field_Butansprechpersonextern3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Butansprechpersonextern3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_butansprechpersonextern3(inputs)
});
export { _field_butansprechpersonextern3 as "_field_butAnsprechPersonExtern" }